import React from "react";
import {
  Breadcrumb,
  DetailFunctionary,
  DetailInstructor,
  Title,
} from "../components";
import { useLocation } from "react-router-dom";

const FunctionaryDetail = () => {
  const location = useLocation();

  console.log(typeof location.state);

  return (
    <div className="container">
      <Breadcrumb current="Detail" />
      <Title title="Hodimlar" subtitle="find the right course for you" />
      <div className="">
        <div className="" id="">
          <DetailFunctionary data={location.state} />
        </div>
      </div>
    
    </div>
  );
};

export default FunctionaryDetail;
